import { useState } from "react"
import { EmailTemplateTypes } from "../../../common/constants"
import { useInvoiceRemindersAvailable } from "../../../domain/invoicing/settings/invoiceReminderScheduleQueries"
import EmailTemplateTypeList from "../../EmailTemplates/EmailTemplateTypeList"
import SettingsTabs from "../SettingsTabs"
import Settings from "./Settings"

const SETTINGS_TAB = 'settings'
const EMAIL_TEMPLATES_TAB = 'email-templates'

const InvoicingSettings = () => {
  const [selectedTab, setSelectedTab] = useState(SETTINGS_TAB)
  const remindersAvailable = useInvoiceRemindersAvailable()

  const tabs = [
    { key: SETTINGS_TAB, label: 'Settings' },
    ...(remindersAvailable ? [{ key: EMAIL_TEMPLATES_TAB, label: 'Reminder Email Templates' }] : [])
  ]

  const showEmailTemplates = selectedTab === EMAIL_TEMPLATES_TAB && remindersAvailable

  return <SettingsTabs selectedTab={selectedTab} onTabChange={setSelectedTab} tabs={tabs}>
    {!showEmailTemplates && <Settings onEditEmailTemplates={() => setSelectedTab(EMAIL_TEMPLATES_TAB)} />}
    {showEmailTemplates && <EmailTemplateTypeList emailTemplateType={EmailTemplateTypes.InvoiceReminder} />}
  </SettingsTabs>
}

export default InvoicingSettings
